import {
  BillableItemIds,
  BillableItemPaymentModel,
  BillableItemStatus,
  BillableItemType,
  CurrencyCode,
  FeatureType
} from '../../enums/billableItem';
import { BillableItem } from '../../interfaces/billableItem';
import { SystemContactLimit } from '../billableItems';

export const appSumoPlans: BillableItem[] = [
  {
    id: BillableItemIds.AppSumoPlan.MobizTier1,
    name: 'AppSumo Lifetime Plan (Tier 1)',
    type: BillableItemType.AppSumoPlan,
    priceInCents: 7900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Lifetime,
    status: BillableItemStatus.Active,
    features: [
      { type: FeatureType.PictureMessaging, quantity: 1 },
      { type: FeatureType.MmsTextOverlay, quantity: 1 },
      {
        type: FeatureType.Sms,
        quantity: 500
      },
      {
        type: FeatureType.Contact,
        quantity: 5000
      }
    ]
  },
  {
    id: BillableItemIds.AppSumoPlan.MobizTier2,
    name: 'AppSumo Lifetime Plan (Tier 2)',
    type: BillableItemType.AppSumoPlan,
    priceInCents: 15900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Lifetime,
    status: BillableItemStatus.Active,
    features: [
      { type: FeatureType.PictureMessaging, quantity: 1 },
      { type: FeatureType.MmsTextOverlay, quantity: 1 },
      {
        type: FeatureType.Sms,
        quantity: 1000
      },
      {
        type: FeatureType.Contact,
        quantity: 10000
      }
    ]
  },
  {
    id: BillableItemIds.AppSumoPlan.MobizTier3,
    name: 'AppSumo Lifetime Plan (Tier 3)',
    type: BillableItemType.AppSumoPlan,
    priceInCents: 24900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Lifetime,
    status: BillableItemStatus.Active,
    features: [
      { type: FeatureType.PictureMessaging, quantity: 1 },
      { type: FeatureType.MmsTextOverlay, quantity: 1 },
      {
        type: FeatureType.Sms,
        quantity: 1500
      },
      {
        type: FeatureType.Contact,
        quantity: 50000
      },
      { type: FeatureType.CustomDomain, quantity: 1 }
    ]
  },
  {
    id: BillableItemIds.AppSumoPlan.MobizTier4,
    name: 'AppSumo Lifetime Plan (Tier 4)',
    type: BillableItemType.AppSumoPlan,
    priceInCents: 35900,
    currencyCode: CurrencyCode.USD,
    paymentModel: BillableItemPaymentModel.Lifetime,
    status: BillableItemStatus.Active,
    features: [
      { type: FeatureType.PictureMessaging, quantity: 1 },
      { type: FeatureType.MmsTextOverlay, quantity: 1 },
      {
        type: FeatureType.Sms,
        quantity: 2000
      },
      {
        type: FeatureType.Contact,
        // this is supposed to be unlimited
        quantity: SystemContactLimit
      },
      { type: FeatureType.CustomDomain, quantity: 1 }
    ]
  }
];
